import type { ScamImageData } from "./types";

export const IMAGE_DATABASE: ScamImageData[] = [
  // { id: "fc1a9b3e", path: "/images/fake-chief_1.png", isScam: true },
  { id: "fc2d8e7f", path: "/images/fake-chief_2.png", isScam: true },
  // { id: "fc3c5a2b", path: "/images/fake-chief_3.png", isScam: true },
  { id: "rc4f1d9a", path: "/images/real-chief.png", isScam: false },
];
